import { Box, type BoxProps } from '@chakra-ui/react'

interface SectionProps extends BoxProps {
  children: React.ReactNode
  id?: string
}

/** Ruled page band: 2px top rule, fluid gutters and vertical rhythm (clamp, no breakpoints). */
export const Section = ({ children, id, ...props }: SectionProps) => (
  <Box
    as="section"
    id={id}
    borderTop="2px solid"
    borderColor="divider"
    px="clamp(20px, 4vw, 48px)"
    pt="clamp(40px, 5vw, 64px)"
    pb="clamp(48px, 5.5vw, 72px)"
    {...props}
  >
    {children}
  </Box>
)
